import React from 'react';

import routeDetails from 'app/constants/routeDetails';

import Link from 'app/components/Link';

import styles from './styles.css';

const FullReportCta = () => (
  <div className={styles.container}>
    <p className={styles.lead}>Would you like a full analysis?</p>
    <Link
      isButton={true}
      label="get the full report"
      to={routeDetails.FULL_ANALYSIS.url}
    />
  </div>
);

export default FullReportCta;



// WEBPACK FOOTER //
// ./src/components/ResultsContainer/FullReportCta/index.js